import React, { useEffect, useRef, useState, useCallback } from 'react'
import { getNotifications } from '../../adapters/users';
import { formatDate } from '../../utils/methods';
import useSocketStore from '../../store/socket'
import { useNavigate } from 'react-router-dom';
import { LoadingData } from '../Loading';

export default function Notifications({ onClose, socket }) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState({});

  const navigate = useNavigate();

  
  const [showOption, setShowOption] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedNotification, setSelectedNotification ] = useState({});
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)
  
  const setNewNotification = useSocketStore((state) => state.setNewNotification);
  
  const loadNotifications = () => {
    setLoading(true);
    getNotifications(page).then((res) => {
      if(res.status === 200) {
        setNotifications(prevNotifications => [...prevNotifications, ...res.data.docs])
        setData(res.data);
        if (res.data.hasNextPage) {
         setHasMore(true);
        }
      }
    })
    setLoading(false);
  }


  useEffect(() => {
    loadNotifications();
  }, [page])
  
  const notifyOptions = (notification) => {
    setShowOption(!showOption);
    if(showOption && notification){
      setSelectedNotification(notification);
    }
  }


  const handleDeletedNotification = (data) => {
    const newNotifications = notifications.filter((no) => no._id !== data._id)
    setNotifications(newNotifications);
  }


  const closeNotifyOptions = () => {
    setShowOption(false);
  }

  const handleNewNotification = (data) => {
    notifications.push(data)
    setNotifications(notifications);
    setNewNotification(true);
  }

  const handleSeendNotification = (data) => {
    const notiIndex = notifications.findIndex((n) => n._id === data._id);
    notifications[notiIndex].readAt = data.readAt;
    setNotifications(notifications);
  }


  const handleSeenNotification = (notification) => {
    socket?.emit('seeNotification', {id: notification._id})
  }

  const navigationHandler = (notification) => {
    handleSeenNotification(notification);
    navigate(`/case-detail/${notification.data.object}`)
    onClose();
  }

  useEffect(() => {

    loadNotifications();
    socket?.on('newNotification', handleNewNotification)
    socket?.on('deletedNotification', handleDeletedNotification)
    socket?.on('seenNotification', handleSeendNotification)
    return () => {
      socket?.off('newNotification');
      socket?.off('deletedNotification')
      socket?.off('seenNotification')
    }
  },[])

  const deleteNotification = () => {
    const notifyId = selectedNotification._id;
    socket?.emit("deleteNotification", { id: notifyId })
  }

  const turnOfNotification = () => {
    socket?.emit("turnOfNotifications", {})
  }

  const observer = useRef();
  const lastNotificationElelmentRef = useCallback(node => {
    if (loading) return
    if(observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if(entries[0].isIntersecting && hasMore){
        setPage(prevPage => prevPage + 1);
      }
    })
    if(node) observer.current.observer(node);
  }, [loading, hasMore])

  return (
    <div className="fixed right-0 top-16 lg:w-96 w-full h-screen z-20 bg-white animate__animated animate__fadeInRightBig">
      <div className="pt-12 pb-18 h-full relative">
        <div className="w-full py-1 z-30 bg-white flex justify-between px-4 absolute top-3 left-0 items-center">
          <button onClick={onClose} className="border-2 rounded-lg border-red-600 text-red-600 px-2 py-1 flex items-center text-xs hover:text-red-800 hover:border-red-800 font-semibold">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </span>
            <span>Close</span>
          </button>
        </div>

        {showOption && <div className="fixed animate__animated animate__fadeInUpBig text-xs border-2 bg-white border-gray-200 w-full bottom-16 rounded-t-2xl shadow-md">
          <div className="relative px-4 py-6">
            <button onClick={closeNotifyOptions} className="absolute right-3 top-3 text-gray-800 hover:text-">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
              </svg>
            </button>
            <ul className="mt-3">
              <li className="py-3 border-gray-200 border-b-2 mt-2 rounded-lg transition ease-in-out delay-150 hover:border-blue-600 hover:text-blue-900 hover:bg-blue-200 px-2">
                <button onClick={deleteNotification} className="font-semibold flex gap-2">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                      <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>
                    Delete Notification
                  </span>
                </button>
              </li>
              <li className="py-3 border-gray-200 border-b-2 mt-2 transition ease-in-out delay-150 hover:border-blue-600 hover:text-blue-900 hover:bg-blue-200 rounded-xl px-2">
                <button onClick={turnOfNotification} className="font-semibold flex gap-2">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                      <path fillRule="evenodd" d="M12 2.25a.75.75 0 01.75.75v9a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM6.166 5.106a.75.75 0 010 1.06 8.25 8.25 0 1011.668 0 .75.75 0 111.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788a.75.75 0 011.06 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>
                    Turn Off Notification
                  </span>
                </button>
              </li>
            </ul>
          </div>
        </div>}

        <div className="h-full overflow-scroll">
          <h4 className="mb-3 mt-3 px-4 font-semibold md:text-lg text-sm">
            Notifications
          </h4>
          <div className="h-8/12 flex flex-col gap-1 justify-end pb-4">
            {notifications.length > 0 && notifications.forEach((nt) => {
              let hasRef = false;
              if(Array.from(notifications).length === nt.index + 1){
                hasRef = true
              }
              return (<div key={nt._id} ref={hasRef && lastNotificationElelmentRef} className={`py-4 border-b border-gray-500 hover:shadow-md px-4 ${nt.readAt && nt.readAt !== null ? 'hover:bg-gray-200' : 'bg-gray-200'} cursor-pointer`}>
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2 w-9/12" onClick={() => {
                    navigationHandler(nt)
                  }}>
                    <span className="py-2 px-2 rounded-full bg-gray-300">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5" />
                      </svg>
                    </span>
                    <div>
                      <h4 className="text-xs pb-0 mb-0">
                        {/* <span className="font-semibold">
                          Johnson Mike
                        </span> */}
                        <span>
                          {/* {nt?.data?.message} */}
                        </span>
                      </h4>
                      <span className="text-xs text-gray-600 font-semibold">{formatDate(nt.createdAt)}</span>
                    </div>
                    
                  </div>

                  <div className="text-xs w-1/12 text-right" onClick={() => notifyOptions(nt)}>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>)
            })}

            {loading && <LoadingData message="Loading Notifications..." />}

            {notifications.length < 1 && <div className="py-8 flex px-4 justify-center ">
              <h4 className="font-normal xl:text-2xl text-xl font-fira">
                No Notifications
              </h4>
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
}
